module.exports = __webpack_public_path__ + "static/media/MemberDealLarge.453a9dc4.png";